import { render, staticRenderFns } from "./client-infomation.vue?vue&type=template&id=b49cc47a&scoped=true"
import script from "./client-infomation.vue?vue&type=script&lang=js"
export * from "./client-infomation.vue?vue&type=script&lang=js"
import style0 from "./client-infomation.vue?vue&type=style&index=0&id=b49cc47a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49cc47a",
  null
  
)

export default component.exports